module.exports = __webpack_public_path__ + "img/galaxy-tab-s7_banner.54d98f0.jpg";